function sortAndRenderArticles() {
  const articles = Array.from(document.querySelectorAll('.new-all-article'));
  articles.sort(function (a, b) {
    const dateA = new Date(a.getAttribute('custom-date'));
    const dateB = new Date(b.getAttribute('custom-date'));
    return dateB - dateA;
  });

  const container = document.querySelector('.new-blog-articles.new-all-articles');
  while (container.firstChild) {
    container.removeChild(container.firstChild);
  }
  const topArticles = articles.slice(0, 8);
  topArticles.forEach(function (article) {
    container.appendChild(article);
  });

  const featuredBlogSection = document.querySelector('.new-featured-blog-section');
  if (featuredBlogSection) {
    featuredBlogSection.classList.add('mm_custom__blog_slider');

    // Initialize the Slick slider after adding the class
    $('.mm_custom__blog_slider ul').slick({
      dots: true,
      arrows: true,
      adaptiveHeight: true,
      autoplay: false,
      autoplaySpeed: 3000,
      prevArrow: '<button type="button" class="slick-prev" aria-label=""><span class="custom-arrow"><svg style="transform: rotate(180deg);" xmlns="http://www.w3.org/2000/svg" width="12.264" height="21.699" viewBox="0 0 12.264 21.699"><defs><style>.a{fill:none;stroke:#fff;stroke-width:2px;}</style></defs><path class="a" d="M-74,254.8l10.142,10.142L-74,275.084" transform="translate(74.707 -254.092)"/></svg></span></button>',
      nextArrow: '<button type="button" class="slick-next" aria-label=""><span class="custom-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="12.264" height="21.699" viewBox="0 0 12.264 21.699"><defs><style>.a{fill:none;stroke:#fff;stroke-width:2px;}</style></defs><path class="a" d="M-74,254.8l10.142,10.142L-74,275.084" transform="translate(74.707 -254.092)"/></svg></span></button>',
    });
  }
}

sortAndRenderArticles();
